
























export default

	props:
		card: Object

	computed:
		aspectRatio: -> 380/216

		link: -> "/#{@card.uri}"

		# If no listing image, then use the landscape marquee image
		image: ->
			if @card.image.length then @card.image
			else @card.marqueeImage[0].landscape

